import { render, staticRenderFns } from "./workouts-related.vue?vue&type=template&id=6856fdaa&"
import script from "./workouts-related.vue?vue&type=script&lang=js&"
export * from "./workouts-related.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports